module.exports = __webpack_public_path__ + "img/user_bg.23af140b.png";